import React, { type PropsWithChildren } from 'react';

import { IFormField } from '../../../../../interfaces';
import { isFieldState } from '../../../../../interfaces/IBaseField';
import { FF_CONTAINER, FF_INPUT } from './formFieldTestIds';
import { FieldError } from '../../../Shared';

import styles from './FormField.module.css';

const FormField: React.FunctionComponent<PropsWithChildren<IFormField>> = ({
  location,
  label,
  id,
  placeholder,
  dataRecurly,
  children,
  fieldStatus,
  type,
  pattern,
}) => {
  const inputInvalidStyles = fieldStatus.hasError ? ` ${styles.ffInvalid}` : '';
  const inputStyles = `${styles.ffInput}${inputInvalidStyles}`;

  let labelStyles = location === 'GTB' ? styles.ffContainerGtb : styles.ffContainer;
  const invalidLabelStyles = fieldStatus.hasError ? ' ffInvalid' : '';
  labelStyles = `${labelStyles}${invalidLabelStyles}`;

  return (
    <label data-testid={FF_CONTAINER} htmlFor={id} className={labelStyles}>
      {label}
      <>
        {children || (
          <input
            className={inputStyles}
            data-testid={FF_INPUT}
            id={id}
            data-recurly={dataRecurly}
            placeholder={placeholder}
            onChange={fieldStatus.changeHandler}
            onBlur={fieldStatus.blurHandler}
            onFocus={fieldStatus.focusHandler}
            value={isFieldState(fieldStatus) ? fieldStatus.value : undefined}
            type={type}
            pattern={pattern}
          />
        )}
        {fieldStatus.hasError && <FieldError errorMsg={fieldStatus.errorMsg} />}
      </>
    </label>
  );
};

FormField.defaultProps = {
  label: '',
  id: '',
  placeholder: '',
  dataRecurly: '',
};

export default FormField;
